module.exports = __webpack_public_path__ + "img/promo_tablet.8106c81.jpg";